import React from 'react';
import {Icon, IconProps, forwardRef} from '@chakra-ui/react';

export const WebResearcherIcon = forwardRef(({...props}: IconProps, ref) => (
  <Icon
    ref={ref}
    viewBox="0 0 197 173"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="80.0642" cy="81.0642" r="77.0642" fill="#F8F8FB" />
    <rect
      x="19.8201"
      y="49.6719"
      width="40.223"
      height="12.2418"
      rx="6.12089"
      fill="#F2D2DC"
    />
    <rect
      x="56.5454"
      y="49.6719"
      width="62.3748"
      height="12.2418"
      rx="6.12089"
      fill="#D23559"
    />
    <rect
      y="67.7422"
      width="56.5453"
      height="12.2418"
      rx="6.12089"
      fill="#F2D2DC"
    />
    <rect
      x="50.1331"
      y="67.7422"
      width="56.5453"
      height="12.2418"
      rx="6.12089"
      fill="#D23559"
    />
    <rect
      x="29.1471"
      y="85.8203"
      width="33.2277"
      height="12.2418"
      rx="6.12089"
      fill="#F2D2DC"
    />
    <rect
      x="56.5454"
      y="85.8203"
      width="68.2042"
      height="12.2418"
      rx="6.12089"
      fill="#D23559"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M149.354 138.199L127.584 113.625L136.207 105.986L157.977 130.561C160.086 132.942 159.866 136.582 157.485 138.692C155.104 140.801 151.464 140.581 149.354 138.199Z"
      fill="#272B47"
    />
    <g filter="url(#filter0_d_2861_19270)">
      <circle
        cx="100.642"
        cy="73.9751"
        r="46.0778"
        transform="rotate(-41.537 100.642 73.9751)"
        stroke="#272B47"
        strokeWidth="11.5195"
        fill="none"
        shapeRendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2861_19270"
        x="34.8128"
        y="10.4818"
        width="126.994"
        height="126.99"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2.33177" />
        <feGaussianBlur stdDeviation="5.82942" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2861_19270"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2861_19270"
          result="shape"
        />
      </filter>
    </defs>
  </Icon>
));
